import { Controller } from "stimulus";
import EmblaCarousel from 'embla-carousel';

export default class EmblaController extends Controller {
  connect() {
    // Grab wrapper nodes
    const rootNode = document.querySelector('.reviewCard-slider');
    const rootNode2 = document.querySelector('.reviewCard-slider2');

    // Grab button nodes
    const prevButtonNode = rootNode.querySelector('.embla__prev');
    const nextButtonNode = rootNode.querySelector('.embla__next');

    // Initialize the carousel
    const embla = EmblaCarousel(rootNode);

    // Add click listeners
    prevButtonNode.addEventListener('click', () => {
      embla.scrollPrev();
    });

    nextButtonNode.addEventListener('click', () => {
      embla.scrollNext();
    });

   if (rootNode2) {
    const embla2 = EmblaCarousel(rootNode2);

    // Grab button nodes for the second carousel
    const prevButtonNode2 = rootNode2.querySelector('.embla__prev');
    const nextButtonNode2 = rootNode2.querySelector('.embla__next');

    // Add click listeners for the second carousel
    prevButtonNode2.addEventListener('click', () => {
      embla2.scrollPrev();
    });

    nextButtonNode2.addEventListener('click', () => {
      embla2.scrollNext();
    });

    const options = {
      active: true,
      breakpoints: {
        '(min-width: 768px)': { active: false },
      },
    }

    const emblaApi2 = EmblaCarousel(rootNode2, options);
  }

    const options = {
      active: true,
      breakpoints: {
        '(min-width: 768px)': { active: false },
      },
    }

    const emblaApi = EmblaCarousel(rootNode, options);
  }
}
